import { Pipe, PipeTransform } from "@angular/core";

/**
 * AtmHealthStatus (backend enum): 0 Unknown (grey), 1 Online (green), 2 Warning/Issues (orange), 3 Offline (red).
 * Usage:
 *   {{ row.healthStatus | atmHealthStatus }}            -> "Online"
 *   [ngClass]="row.healthStatus | atmHealthStatus:'badge'" -> badge background/text classes
 *   [ngClass]="row.healthStatus | atmHealthStatus:'dot'"   -> dot background class
 */
@Pipe({
  name: "atmHealthStatus",
})
export class AtmHealthStatusPipe implements PipeTransform {
  transform(
    value: number | null | undefined,
    mode: "label" | "badge" | "dot" | "text" = "label",
  ): string {
    const status = value ?? 0;
    switch (mode) {
      case "badge":
        switch (status) {
          case 1:
            return "bg-g50 text-g400";
          case 2:
            return "bg-y50 text-y400";
          case 3:
            return "bg-r50 text-r300";
          default:
            return "bg-n20 text-n400";
        }
      case "dot":
        switch (status) {
          case 1:
            return "bg-g400";
          case 2:
            return "bg-y400";
          case 3:
            return "bg-r300";
          default:
            return "bg-n300";
        }
      case "text":
        switch (status) {
          case 1:
            return "text-g400";
          case 2:
            return "text-y400";
          case 3:
            return "text-r300";
          default:
            return "text-n400";
        }
      default:
        switch (status) {
          case 1:
            return "Online";
          case 2:
            return "Issues";
          case 3:
            return "Offline";
          default:
            return "Unknown";
        }
    }
  }
}
